<script>
  export let model;
  import RowsContainer from "../container/RowsContainer.svelte";
  import StepperHeadline from "../stepper/StepperHeadline.svelte";

  import Image from "../display/Image.svelte";
  import Loading from "../display/Loading.svelte";
  import Button from "../ui/Button.svelte";
  import { createEventDispatcher } from "svelte";

  import { showLoading } from "../../stores/mainStore";

    const dispatch = createEventDispatcher();

  const action = () => dispatch("action");
</script>

<StepperHeadline>
  <h1>
    Here’s your
    <span class="text-bluelighter">first</span>
    sneak-peek
  </h1>
  <p>
    GETitOUT comes with
    <b>many different templates,</b>
    <br />
    and helps you create all your marketing materials in minutes
  </p>
</StepperHeadline>
<div class="mt-6" class:hidden={$showLoading}>
  <div class="sm:flex-row text-center">
    <span class="sm:flex-grow" />
    <Button class="sm:mr-4 sm:w-auto w-full mt-4 mb-4 sm:mb-0" on:submit={action} raised={true}>
    Nah, put me finally on the waitlist.
    </Button>

    <Button type="submit" raised={true} primary={true} class="sm:w-auto w-full">
      Let’s generate some text... and your website!
    </Button>
    <span class="sm:flex-grow" />
  </div>
</div>
<div class="relative">
  <RowsContainer>
    <div class="text-center sm:px-14">
      <div class="flex flex-row">
        <span class="flex-grow" />
        <svg class="text-xl h-5 my-auto mr-2" viewBox="0 0 22 16">
          <path
            d="M19.046 0L2.246 0C1.091 0 0.156496 0.9 0.156496 2L0.145996
            14C0.145996 15.1 1.091 16 2.246 16H19.046C20.201 16 21.146 15.1
            21.146 14V2C21.146 0.9 20.201 0 19.046 0ZM19.046 4L10.646 9L2.246
            4V2L10.646 7L19.046 2V4Z" />
        </svg>
        <h2 class="text-2xl">Your Newsletter</h2>
        <span class="flex-grow" />

      </div>
      {#if model.previewUrlPaths.email != null}
        <Image
          src={model.previewUrlPaths.email}
          isExternal={true}
          class="shadow-2xl rounded-lg mt-2" />
      {/if}
    </div>
    <div class="text-center" style="min-width:45%">
      <div class="flex flex-row">
        <span class="flex-grow" />

        <svg class="text-xl h-6 my-auto mr-2" viewBox="0 0 12 23">
          <path
            d="M3.06332 23V12.2077H0V8.322H3.06332V5.00307C3.06332 2.39504
            4.87284 0 9.04235 0C10.7305 0 11.9788 0.150765 11.9788
            0.150765L11.8805 3.77938C11.8805 3.77938 10.6074 3.76784 9.21814
            3.76784C7.71455 3.76784 7.47365 4.41333 7.47365
            5.48469V8.322H12L11.8031 12.2077H7.47365V23H3.06332Z" />
        </svg>

        <h2 class="text-2xl">Your Facebook Cover</h2>
        <span class="flex-grow" />

      </div>
      {#if model.previewUrlPaths.facebookCover != null}
        <Image
          src={model.previewUrlPaths.facebookCover}
          isExternal={true}
          class="shadow-2xl rounded-lg mt-2" />
      {/if}
      <p class="mt-8">
        It takes
        <b>just one minute</b>
        to generate your website hero texts.
        <br />
        And we’ll even create a conversion-optimized design with your brand.
      </p>
    </div>
    <div class="text-center sm:px-14">
      <div class="flex flex-row">
        <span class="flex-grow" />

        <svg class="text-xl h-6 my-auto mr-2" viewBox="0 0 21 21">
          <path
            d="M10.5 7.896C9.98498 7.896 9.48152 8.04872 9.05329 8.33485C8.62507
            8.62098 8.29131 9.02767 8.09422 9.50349C7.89713 9.97931 7.84556
            10.5029 7.94603 11.008C8.04651 11.5131 8.29452 11.9771 8.65869
            12.3413C9.02287 12.7055 9.48686 12.9535 9.99198 13.054C10.4971
            13.1544 11.0207 13.1029 11.4965 12.9058C11.9723 12.7087 12.379
            12.3749 12.6651 11.9467C12.9513 11.5185 13.104 11.015 13.104
            10.5C13.104 10.158 13.0366 9.81942 12.9058 9.50349C12.7749 9.18756
            12.5831 8.9005 12.3413 8.65869C12.0995 8.41689 11.8124 8.22508
            11.4965 8.09422C11.1806 7.96335 10.842 7.896 10.5 7.896ZM20.9265
            5.3235C20.921 4.51265 20.7717 3.7092 20.4855 2.9505C20.2747 2.39532
            19.9487 1.89115 19.5288 1.47124C19.1089 1.05134 18.6047 0.725253
            18.0495 0.5145C17.2908 0.228337 16.4874 0.0790239 15.6765
            0.0734999C14.322 -7.0408e-08 13.923 0 10.5 0C7.077 0 6.678
            -7.0408e-08 5.3235 0.0734999C4.51265 0.0790239 3.7092 0.228337
            2.9505 0.5145C2.39532 0.725253 1.89115 1.05134 1.47124
            1.47124C1.05134 1.89115 0.725253 2.39532 0.5145 2.9505C0.228337
            3.7092 0.0790239 4.51265 0.0734999 5.3235C-7.0408e-08 6.678 0 7.077
            0 10.5C0 13.923 -7.0408e-08 14.322 0.0734999 15.6765C0.0848021
            16.4902 0.233913 17.2961 0.5145 18.06C0.724319 18.6126 1.05014
            19.1139 1.47 19.53C1.8881 19.9524 2.39336 20.2785 2.9505
            20.4855C3.7092 20.7717 4.51265 20.921 5.3235 20.9265C6.678 21 7.077
            21 10.5 21C13.923 21 14.322 21 15.6765 20.9265C16.4874 20.921
            17.2908 20.7717 18.0495 20.4855C18.6066 20.2785 19.1119 19.9524
            19.53 19.53C19.9499 19.1139 20.2757 18.6126 20.4855 18.06C20.7714
            17.2976 20.9207 16.4907 20.9265 15.6765C21 14.322 21 13.923 21
            10.5C21 7.077 21 6.678 20.9265 5.3235ZM18.2595 13.7235C18.2258
            14.3715 18.0875 15.0097 17.85 15.6135C17.6462 16.1172 17.3431
            16.5747 16.9589 16.9589C16.5747 17.3431 16.1172 17.6462 15.6135
            17.85C15.004 18.0743 14.3622 18.1984 13.713 18.2175H7.287C6.63782
            18.1984 5.99601 18.0743 5.3865 17.85C4.86581 17.6565 4.39559 17.3478
            4.011 16.947C3.63055 16.5703 3.33674 16.1153 3.15 15.6135C2.92483
            15.0046 2.80414 14.3621 2.793 13.713V10.5V7.287C2.80414 6.63792
            2.92483 5.99538 3.15 5.3865C3.3435 4.86581 3.65219 4.39559 4.053
            4.011C4.43135 3.6326 4.88593 3.3391 5.3865 3.15C5.99601 2.92573
            6.63782 2.80162 7.287 2.7825H13.713C14.3622 2.80162 15.004 2.92573
            15.6135 3.15C16.1342 3.3435 16.6044 3.65219 16.989 4.053C17.3694
            4.42969 17.6633 4.88474 17.85 5.3865C18.0743 5.99601 18.1984 6.63782
            18.2175 7.287V10.5C18.2175 12.663 18.291 12.8835 18.2595
            13.713V13.7235ZM16.5795 5.9115C16.4545 5.57233 16.2574 5.26432
            16.0018 5.00872C15.7462 4.75312 15.4382 4.55602 15.099 4.431C14.6333
            4.26957 14.1428 4.19138 13.65 4.2H7.35C6.85468 4.20484 6.36412
            4.29727 5.901 4.473C5.56703 4.59234 5.26228 4.7814 5.00701
            5.02761C4.75175 5.27382 4.55181 5.57155 4.4205 5.901C4.26802 6.36863
            4.19352 6.85817 4.2 7.35V13.65C4.21041 14.1448 4.30266 14.6344 4.473
            15.099C4.59802 15.4382 4.79512 15.7462 5.05072 16.0018C5.30632
            16.2574 5.61433 16.4545 5.9535 16.5795C6.4015 16.7443 6.87294
            16.8364 7.35 16.8525H13.65C14.1453 16.8477 14.6359 16.7552 15.099
            16.5795C15.4382 16.4545 15.7462 16.2574 16.0018 16.0018C16.2574
            15.7462 16.4545 15.4382 16.5795 15.099C16.7552 14.6359 16.8477
            14.1453 16.8525 13.65V10.5V7.35C16.8528 6.85419 16.7602 6.36271
            16.5795 5.901V5.9115ZM10.5 14.511C9.97376 14.511 9.45269 14.4072
            8.96665 14.2055C8.4806 14.0038 8.03912 13.7082 7.6675
            13.3356C7.29588 12.963 7.00143 12.5207 6.801 12.0341C6.60058 11.5476
            6.49812 11.0262 6.4995 10.5C6.4995 9.70625 6.73501 8.93035 7.17621
            8.27052C7.61741 7.61069 8.24446 7.0966 8.97799 6.79332C9.71152
            6.49005 10.5185 6.41124 11.2969 6.56686C12.0752 6.72247 12.7899
            7.10553 13.3504 7.66753C13.9109 8.22953 14.2921 8.9452 14.4457
            9.72395C14.5993 10.5027 14.5184 11.3095 14.2132 12.0422C13.908
            12.775 13.3922 13.4007 12.7312 13.8401C12.0703 14.2796 11.2937
            14.5131 10.5 14.511ZM14.7 7.2765C14.4679 7.25193 14.2531 7.14233
            14.097 6.96882C13.9409 6.79531 13.8545 6.57016 13.8545
            6.33675C13.8545 6.10334 13.9409 5.87819 14.097 5.70468C14.2531
            5.53117 14.4679 5.42157 14.7 5.397C14.9321 5.42157 15.1469 5.53117
            15.303 5.70468C15.4591 5.87819 15.5455 6.10334 15.5455
            6.33675C15.5455 6.57016 15.4591 6.79531 15.303 6.96882C15.1469
            7.14233 14.9321 7.25193 14.7 7.2765Z" />
        </svg>

        <h2 class="text-2xl">Your Instagram Post</h2>
        <span class="flex-grow" />

      </div>
      {#if model.previewUrlPaths.instagramPost != null}
        <Image
          isExternal={true}
          src={model.previewUrlPaths.instagramPost}
          class="shadow-2xl rounded-lg mt-2" />
      {/if}
    </div>
  </RowsContainer>
  {#if $showLoading}
    <div class="absolute top-0 left-0 w-full h-full bg-white" style="min-height:500px;">
      <Loading mode={1} />
    </div>
  {/if}
</div>
